import React from 'react';
import { Link } from 'react-router-dom';
import { FaFacebook, FaInstagram } from 'react-icons/fa';
import logoImage from "./assets/Logo/0.02.png";

const Footer = () => {
  return (
    <footer className="bg-yellow text-black py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {/* Logo and Description */}
          <div className="md:col-span-2 lg:col-span-2">
            <Link to="/" className="inline-block mb-4">
              <img 
                src={logoImage} 
                alt="Bioresonance Logo" 
                className="block max-h-72 w-auto object-scale-down align-middle"
              />
            </Link>
            <p className="text-gray-700 mb-4 max-w-md">
              Frequency therapy based on bioresonance principles (Bicom),
              developed by Regumed GmbH—advancing therapeutic development and professional training since 1987.
            </p>
          </div>

          {/* Quick Links */}
          <div className="mt-14 md:mt-16">
            <h3 className="text-lg font-semibold mb-4 text-gold">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/therapy" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/prices" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Prices
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-gray-700 hover:text-gold transition-colors duration-300">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="mt-14 md:mt-16">
            <h3 className="text-lg font-semibold mb-4 text-gold">Contact Info</h3>
            <div className="space-y-2 text-gray-700">
              <p className="font-medium">TP Wellness</p>
              <p>108 New Walk</p>
              <p>3rd Floor, Room 303</p>
              <p>LE1 7EA Leicester</p>
              <p>Phone: 0776 137 4278</p>
              <p>Phone: 0792 382 5242</p>
              <p>Email: info@bioresonance-leicester.co.uk</p>
            </div>
          </div>

          {/* Opening Hours */}
          <div className="mt-14 md:mt-16">
            <h3 className="text-lg font-semibold mb-4 text-gold">Opening Hours</h3>
            <div className="space-y-1 text-gray-700 text-sm">
              <p><span className="font-medium">Monday</span> <span className="text-red-600">Closed</span></p>
              <p><span className="font-medium">Tuesday</span> <span className="text-red-600">Closed</span></p>
              <p><span className="font-medium">Wednesday</span> 9:30 AM – 8:00 PM</p>
              <p><span className="font-medium">Thursday</span> 9:30 AM – 8:00 PM</p>
              <p><span className="font-medium">Friday</span> 9:30 AM – 8:00 PM</p>
              <p><span className="font-medium">Saturday</span> 8:00 AM – 8:00 PM</p>
              <p><span className="font-medium">Sunday</span> 8:00 AM – 8:00 PM</p>
            </div>
          </div>
        </div>

        {/* Social Links */}
        <div className="flex justify-center gap-6 mt-6">
          <a
            href="https://www.facebook.com/BioresonanceLeicesterUK"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-gold transition-colors duration-300"
            aria-label="Facebook"
          >
            <FaFacebook size={28} />
          </a>
          <a
            href="https://www.instagram.com/bioresonance_leicester/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-gray-700 hover:text-gold transition-colors duration-300"
            aria-label="Instagram"
          >
            <FaInstagram size={28} />
          </a>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-400 mt-6 pt-6 text-center text-gray-600">
          <p>&copy; 2025 T&P Wellness. All rights reserved.</p>
          <p className="mt-1 text-sm">Est. 2017.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
